import styled from '@emotion/styled';

export const StyledProjectPreviewList = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
`;
